import types from '$lib/item-type-props';
import { extractContainersFromItem, getItemPrice } from '$lib/utils';

export const itemLink = (item) => `/skins/gloves/${item.skinGroup.weapon.slug}/${item.slug}`;
export const generate = (data) => ({
  jumbo: {
    extraText:
      'Enter the name of a glove into the search box to instantly find the glove you are looking for. Alternatively, use the Sort By dropdown to sort the gloves by price or release date. Click the "Card" and "Table" buttons to change how the skins are displayed.',
  },
  card: types.skinGroup,
  meilisearch: {
    type: 'skinGroup',
  },
  table: {
    columns: [
      {
        label: 'Containers',
        value: extractContainersFromItem,
        preset: 'found_in',
        width: 20,
        modifiers: ['w-justify-center', 'w-center', 'w-1200-100'],
        order: 5,
      },
    ],
  },
});
